import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonComment } from '@app/interfaces/rm/resource-comment';
import { Auth } from '@app/interfaces/sys/auth';

@Component({
    selector: 'app-comment',
    templateUrl: './comment.component.html',
    styleUrls: ['./comment.component.less'],
})
export class CommentComponent implements OnInit {
    @Input() data: CommonComment[] = [];
    @Input() submitLoading = false;
    @Input() loading = false;
    @Input() disabledSubmit = false;
    @Input() uploadPath!: string;
    @Input() disabledCancel = false;
    @Input() isEditorComment = false;
    @Input() hasEditDeleteBtn = false;
    @Input() hasRolePermission = false;
    @Input() needDisabledEditDeleteBtn = true;
    @Output() submitComment = new EventEmitter();
    @Output() deleteComment = new EventEmitter();
    @Output() editComment = new EventEmitter();
    comment = '';
    currentUser!: Auth;
    editRow!: CommonComment | null;
    constructor() {
    }

    ngOnInit(): void {
        const info = localStorage.getItem('tokenData');
        this.currentUser = info ? JSON.parse(info) : null;
    }

    onCancel(): void {
        this.editRow = null;
        this.resetComment();
    }

    onSubmit(): void {
        this.editRow = null;
        this.submitComment.emit();
    }

    resetComment(): void {
        this.comment = '';
    }

    resetRowEdit(editItem: CommonComment): void {
        const { id } = editItem;
        const index = this.data.findIndex(item => item.id === id);
        if (!index && index !== 0) {
            this.editRow = null;
            return;
        }
        this.data.splice(index, 1, editItem);
        this.editRow = null;
    }

    edit(item: CommonComment): void {
        this.editRow = {...item};
    }

    delete(id: string): void {
        this.deleteComment.emit(id);
    }

    canEditDelete(row: CommonComment): boolean {
        return this.hasRolePermission || row.createdById?.toString() === this.currentUser.id.toString();
    }

    cancelEdit(item: CommonComment): void {
        item.commentMessage = this.editRow?.commentMessage || '';
        this.editRow = null;
    }

    handEdit(item: CommonComment): void {
        this.editComment.emit(item);
    }
}
